import approx from 'approximate-number'

export default function(value, options) {
  if (!value) {
    return ''
  }

  return approx(value, options)
}
